import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postConsents } from './agreement.api'
import { agreementQueryKeys } from './agreement.queries'
import type { CreateConsentsRequest } from '~/shared/agreement/agreement.api.schema'

export const useCreateConsents = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateConsentsRequest) => postConsents(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: agreementQueryKeys.missing })
    },
  })
}
